import _ from 'lodash';

export const getFormattedTableData = (locations, extraProps) => {
  if (!locations.length) {
    return [];
  }

  const { onEdit, onDelete, ...restProps } = extraProps;

  return _.map(locations, location => ({
    ...location,
    ...restProps,
    id: location.feeProviderLocationId,
    onEdit: () => onEdit(location.feeProviderLocationId),
    onDelete: () => onDelete(location.feeProviderLocationId),
  }));
};
